var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"select-dropdown"},[_c('ul',{staticClass:"ant-select-dropdown-menu"},[_c('li',{staticClass:"ant-select-dropdown-menu-item ant-select-dropdown-menu-item-selected"},[_c('span',[_vm._v("1111")])]),_c('li',{staticClass:"ant-select-dropdown-menu-item"},[_c('span',[_vm._v("1111")])])])])
}]

export { render, staticRenderFns }